module.exports = "https://www.gc-qa.gnp.com.mx/66c26c65f909e860fd5781e6ef3af10c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/boton/05.png
// module id = 1010
// module chunks = 0 1